const SelectCustomDropdown = () => {
    return (
      <div className="p-2 cursor-pointer">
        <svg
          className="flex-shrink-0 ml-2 mr-1 fill-current text-gray-400"
          width="11"
          height="7"
          viewBox="0 0 11 7">
          <path d="M5.4 6.8L0 1.4 1.4 0l4 4 4-4 1.4 1.4z" />
        </svg>
      </div>
    );
};

export default SelectCustomDropdown;
  